import React, { useState } from 'react';
import { ArrowRightIcon, CheckCircleIcon, ClockIcon, HistoryIcon, SearchIcon, BarChart3Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LogList } from './LogList';
import { AutomatedDataList } from './AutomatedDataList';
import { Analytics } from './Analytics';
export function Dashboard() {
  const [showHistory, setShowHistory] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [activeTab, setActiveTab] = useState<'laufend' | 'abgeschlossen'>('laufend');
  const [searchTerm, setSearchTerm] = useState('');
  const [historyTab, setHistoryTab] = useState<'proben' | 'datenerfassung'>('proben');
  const laufendeAuftraege = [{
    id: 'A1234',
    name: 'CT:Slurry Prod.',
    charge: 'Optidi 58',
    startDate: '22.04.2025',
    status: 'In Produktion'
  }];
  const abgeschlosseneAuftraege = [{
    id: 'A1230',
    name: 'CT:Slurry Prod.',
    charge: 'Optidi 54',
    completionDate: '21.04.2025',
    menge: '61.5t'
  }, {
    id: 'A1229',
    name: 'CT:Slurry Prod.',
    charge: 'Optidi 53',
    completionDate: '20.04.2025',
    menge: '58.2t'
  }, {
    id: 'A1228',
    name: 'CT:Slurry Prod.',
    charge: 'Optidi 52',
    completionDate: '19.04.2025',
    menge: '62.8t'
  }, {
    id: 'A1227',
    name: 'CT:Slurry Prod.',
    charge: 'Optidi 51',
    completionDate: '18.04.2025',
    menge: '59.4t'
  }, {
    id: 'A1226',
    name: 'CT:Slurry Prod.',
    charge: 'Optidi 50',
    completionDate: '17.04.2025',
    menge: '60.7t'
  }];
  const filteredAuftraege = abgeschlosseneAuftraege.filter(auftrag => auftrag.id.toLowerCase().includes(searchTerm.toLowerCase()) || auftrag.name.toLowerCase().includes(searchTerm.toLowerCase()) || auftrag.charge.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6 max-h-screen pb-6" data-id="element-302">
      <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-303">
        <h2 className="text-lg font-bold text-gray-800 mb-1" data-id="element-304">
          Auftragsübersicht
        </h2>
        <p className="text-sm text-gray-500" data-id="element-305">
          Aktuelle und abgeschlossene Produktionsaufträge
        </p>
      </div>
      <div className="bg-white rounded-lg shadow-sm" data-id="element-306">
        <div className="border-b border-gray-200" data-id="element-307">
          <div className="flex" data-id="element-308">
            <button onClick={() => setActiveTab('laufend')} className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 'laufend' ? 'border-[#3498dd] text-[#3498dd]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-309">
              Laufend
              <span className="ml-2 px-2 py-0.5 bg-blue-50 text-[#3498dd] rounded-full text-xs" data-id="element-310">
                {laufendeAuftraege.length}
              </span>
            </button>
            <button onClick={() => setActiveTab('abgeschlossen')} className={`px-4 py-2 text-sm font-medium border-b-2 ${activeTab === 'abgeschlossen' ? 'border-[#3498dd] text-[#3498dd]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-311">
              Abgeschlossen
              <span className="ml-2 px-2 py-0.5 bg-green-50 text-green-600 rounded-full text-xs" data-id="element-312">
                {abgeschlosseneAuftraege.length}
              </span>
            </button>
          </div>
        </div>
        <div className="p-4" data-id="element-313">
          {activeTab === 'laufend' && <div className="space-y-3" data-id="element-314">
              {laufendeAuftraege.map(auftrag => <div key={auftrag.id} className="border border-gray-200 rounded-lg p-4" data-id="element-315">
                  <div className="flex justify-between items-start mb-3" data-id="element-316">
                    <div data-id="element-317">
                      <h4 className="text-sm font-semibold text-gray-800" data-id="element-318">
                        {auftrag.name}
                      </h4>
                      <p className="text-xs text-gray-500" data-id="element-319">
                        Charge: {auftrag.charge}
                      </p>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-320">
                      <button onClick={() => setShowHistory(true)} className="flex items-center text-xs text-gray-600 hover:text-gray-800 px-2 py-1 rounded border border-gray-200 hover:bg-gray-50" data-id="element-321">
                        <HistoryIcon size={14} className="mr-1" data-id="element-322" />
                        Historie
                      </button>
                      <Link to="/production/view" className="flex items-center text-xs text-[#3498dd] hover:text-blue-600" data-id="element-323">
                        Zur Produktion
                        <ArrowRightIcon size={14} className="ml-1" data-id="element-324" />
                      </Link>
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-xs" data-id="element-325">
                    <div className="flex items-center" data-id="element-326">
                      <ClockIcon size={14} className="text-gray-400 mr-1" data-id="element-327" />
                      <span className="text-gray-600" data-id="element-328">
                        Start: {auftrag.startDate}
                      </span>
                    </div>
                    <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded" data-id="element-329">
                      {auftrag.status}
                    </span>
                  </div>
                </div>)}
            </div>}
          {activeTab === 'abgeschlossen' && <div data-id="element-330">
              <div className="mb-4 flex justify-between items-center" data-id="element-331">
                <div className="relative" data-id="element-332">
                  <input type="text" placeholder="Suche nach Auftrag, Name oder Charge..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:border-[#3498dd]" data-id="element-333" />
                  <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-334" />
                </div>
                <button onClick={() => setShowAnalytics(true)} className="flex items-center gap-2 px-4 py-2 bg-[#3498dd] text-white rounded-lg text-sm hover:bg-blue-600 transition-colors" data-id="element-335">
                  <BarChart3Icon size={16} data-id="element-336" />
                  Auswertung
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-337">
                <table className="min-w-full" data-id="element-338">
                  <thead data-id="element-339">
                    <tr className="text-xs text-gray-500" data-id="element-340">
                      <th className="px-4 py-2 text-left" data-id="element-341">Auftrag</th>
                      <th className="px-4 py-2 text-left" data-id="element-342">Charge</th>
                      <th className="px-4 py-2 text-left" data-id="element-343">Abschluss</th>
                      <th className="px-4 py-2 text-left" data-id="element-344">Menge</th>
                      <th className="px-4 py-2 text-left" data-id="element-345">Status</th>
                      <th className="px-4 py-2 text-left" data-id="element-346">Aktionen</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100" data-id="element-347">
                    {filteredAuftraege.map(auftrag => <tr key={auftrag.id} className="text-sm" data-id="element-348">
                        <td className="px-4 py-3 text-gray-800" data-id="element-349">
                          <div data-id="element-350">
                            <span className="font-medium" data-id="element-351">{auftrag.id}</span>
                            <br data-id="element-352" />
                            <span className="text-xs text-gray-500" data-id="element-353">
                              {auftrag.name}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-gray-600" data-id="element-354">
                          {auftrag.charge}
                        </td>
                        <td className="px-4 py-3 text-gray-600" data-id="element-355">
                          {auftrag.completionDate}
                        </td>
                        <td className="px-4 py-3 text-gray-600" data-id="element-356">
                          {auftrag.menge}
                        </td>
                        <td className="px-4 py-3" data-id="element-357">
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-50 text-green-600" data-id="element-358">
                            <CheckCircleIcon size={12} className="mr-1" data-id="element-359" />
                            Abgeschlossen
                          </span>
                        </td>
                        <td className="px-4 py-3" data-id="element-360">
                          <button onClick={() => setShowHistory(true)} className="text-xs text-gray-600 hover:text-gray-800" data-id="element-361">
                            <HistoryIcon size={14} data-id="element-362" />
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
        </div>
      </div>
      {showHistory && <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-363">
          <div className="bg-white rounded-lg w-[90vw] max-w-6xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-364">
            <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-365">
              <h3 className="text-lg font-semibold text-gray-800" data-id="element-366">
                Historie -{' '}
                {activeTab === 'abgeschlossen' ? filteredAuftraege[0]?.charge : laufendeAuftraege[0].charge}
              </h3>
              <button onClick={() => setShowHistory(false)} className="text-gray-500 hover:text-gray-700" data-id="element-367">
                ✕
              </button>
            </div>
            <div className="border-b border-gray-200" data-id="element-368">
              <div className="flex" data-id="element-369">
                <button onClick={() => setHistoryTab('proben')} className={`px-4 py-2 text-sm font-medium border-b-2 ${historyTab === 'proben' ? 'border-[#3498dd] text-[#3498dd]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-370">
                  Proben
                </button>
                <button onClick={() => setHistoryTab('datenerfassung')} className={`px-4 py-2 text-sm font-medium border-b-2 ${historyTab === 'datenerfassung' ? 'border-[#3498dd] text-[#3498dd]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-371">
                  Datenerfassung
                </button>
              </div>
            </div>
            <div className="flex-1 overflow-auto p-4" data-id="element-372">
              {historyTab === 'proben' ? <LogList isCompleted={activeTab === 'abgeschlossen'} data-id="element-373" /> : <AutomatedDataList data-id="element-374" />}
            </div>
          </div>
        </div>}
      {showAnalytics && <Analytics onClose={() => setShowAnalytics(false)} orders={abgeschlosseneAuftraege} data-id="element-375" />}
    </div>;
}